import {Header} from 'primeng/shared';

export class SelfScanService {
  public id?: number;
  public customer_id: number;
  public channel_id: number;
  public message_id: number;
  public uid_chk_chance: string;
  public number_trx_checked: number;
  public number_trx_used: number;
  public date_last_trx: string;
  public time_trx: string;
  public number_last_check: number;
  public number_next_check: number;
  public uid_last_check_chance: string;
  public last_chk_status: string;
  public flg_blk_ss: string;
  public spot_chk_status: number;
  public time_last_chk: string;
  public not_payed_trx: number;
  public trx_tot_time: number;
  public num_forced_rescan: number;
  public num_up_rescan: number;
  public num_down_rescan: number;
  public num_eq_rescan: number;
  public last_chk_chance: string;
  public curr_chk_chance: string;
  public def_lng_term: string;
  public flg_low_line: string;
  public reason_id: number;
  public customer_service_id: number;
  public flg_state: string;
}

export class SelfScanServiceDetail {
  public id?: number;
  public self_scanning_service_id: number;
  public division_id: number;
  public store_id: number;
  public trx_num: number;
  public term_id: number;
  public operator_id: string;
  public trx_date: string;
  public time_trx: string;
  public card_id: number;
  public customer_id: number;
  public flg_chk_result: string;
  public rmnd_val: number;
  public flg_chk: string;
  public last_chk_chance: string;
  public curr_chk_chance: string;
  public number_trx_checked: number;
  public number_trx_used: number;
  public number_last_check: number;
  public spot_chk_status: number;
  public time_last_chk: string;
  public reason_id: number;
  public not_payed_trx: number;
  public num_forced_rescan: number;
  public num_up_rescan: number;
  public num_eq_rescan: number;
  public num_down_rescan: number;
  public flg_host_status: string;
  public trx_json: string;
  public trx_json_app: string;
  public customer_description: string;
  public store_name: string;
}

export class SelfScanServiceTrx {
  public header: BigHeader;
  public items: ItemJson[];
}

export class BigHeader {
  public app: HeaderJson;
  public cassa: HeaderJson;
}

export class HeaderJson {
  public totalAmount: number;
  public selfScanSessionId: number;
  public itemsNumber: number;
  public startTime: string;
  public endTime: string;
  public trxNum: number;
  public termCode: string;
  public storeCode: string;
}

export class ItemJson {
  public itemId: string;
  public quantity_cassa: number;
  public quantity_app: number;
  public action: string;
  public regularPrice_cassa: number;
  public regularPrice_app: number;
  public barcode: string;
  public check_price: string;
  public check_quantity: string;
}







// WEBPACK FOOTER //
// ./src/app/models/loyalty-selfScan-service.model.ts